import { _defineProperty } from "./index13.js";
import mitt from "mitt";
var SuperMitt = class {
	constructor() {
		_defineProperty(this, "mitt", void 0);
		this.mitt = mitt();
	}
	get all() {
		return this.mitt.all;
	}
	get on() {
		return this.mitt.on;
	}
	get emit() {
		return this.mitt.emit;
	}
	get off() {
		return this.mitt.off;
	}
	once(type, handler) {
		const callback = (props) => {
			handler(props);
			this.mitt.off(type, callback);
		};
		this.mitt.on(type, callback);
	}
	async wait(type) {
		return new Promise((resolve) => this.once(type, resolve));
	}
};
export { SuperMitt };

//# sourceMappingURL=index229.js.map